import React from 'react';
import './NotFound.scss';
// Assuming you have an AnimatedSection or similar component for the main view animation
// import AnimatedSection from '../../components/Ui/AnimatedSection'; 

const NotFound = () => {
  return (
    <section className="not-found-section">
      <div className="not-found-container">
        
        {/* Animated 404 Code */}
        <div className="not-found-code-wrapper">
          <span className="code-digit animate-left">4</span>
          <span className="code-digit animate-center">0</span>
          <span className="code-digit animate-right">4</span>
        </div>

        {/* Content */}
        <div className="not-found-content">
          <h1 className="not-found-title">Oops! Page Not Found</h1>
          <p className="not-found-description">
            We couldn't find the page you were looking for. It might have been moved or deleted.
          </p>
          
          {/* Call to Action Button */}
          <a href="/" className="back-home-btn">
            Go Back To Homepage
          </a>
        </div>
        
        {/* Subtle Background Animation/Graphic (Optional) */}
        <div className="error-graphic-overlay"></div>
      </div>
    </section>
  );
};

export default NotFound;